// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import EuroCircleFilledSvg from "@ant-design/icons-svg/es/asn/EuroCircleFilled";
import AntdIcon from '../components/AntdIcon';

var EuroCircleFilled = function EuroCircleFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: EuroCircleFilledSvg
  }));
};

EuroCircleFilled.displayName = 'EuroCircleFilled';
export default React.forwardRef(EuroCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/EuroCircleFilled.js
// module id = 1019
// module chunks = 0